export default __webpack_public_path__ + "static/media/annex8.5e2eed9a.png";